import { addColumnHeader } from "../helpers";
import { parseCustomDate } from "../utils";
export const dateAndCharacterCode = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns,
) => {
  addColumnHeader(outputSheet, outputColumns, rule.outputColumn);

  const useOutputOf = rules.find(
    (rle) => parseInt(rle._id) === parseInt(rule.useOutputOf),
  );

  if (useOutputOf) {
    if (useOutputOf.ranges) {
    } else {
      let findRuleColumn = inputColumns.find(
        (cl) => cl.inColChr === useOutputOf.inputColumn,
      );

      let characterCodes = createObjectFromArray(inputColumns);
      insertUsingIndexes(
        worksheet,
        outputSheet,
        rule.inputColumns,
        rule.outputColumn,
        findRuleColumn.dateFormat,
        useOutputOf.inputColumn,
        useOutputOf.output,
        characterCodes,
      );
    }
  }
};

const insertUsingIndexes = (
  worksheet,
  outputSheet,
  inputColumns,
  outputColumn,
  dateFormat, // format that date already is in
  dateColumn,
  indexes,
  characterCodes,
) => {
  let outputRow = { currentIndex: 2 };
  indexes.forEach((indx) => {
    insertData(
      worksheet,
      outputSheet,
      inputColumns,
      outputColumn,
      dateFormat, // format that date already is in
      dateColumn,
      indx,
      outputRow,
      characterCodes,
    );
  });
};

const insertData = (
  worksheet,
  outputSheet,
  inputColumns,
  outputColumn,
  dateFormat, // format that date already is in
  dateColumn,
  indx,
  outputRow,
  characterCodes,
) => {
  let newDate = worksheet.getCell(`${dateColumn}${indx}`).value;

  let formatedDate = parseCustomDate(newDate, dateFormat);
  inputColumns.forEach((col) => {
    outputSheet.getCell(`${outputColumn}${outputRow.currentIndex}`).value =
      `${formatedDate}` + characterCodes[col];
    outputRow.currentIndex++;
  });
};

function createObjectFromArray(arr) {
  const result = {};
  arr.forEach((item) => {
    result[item.inColChr] = item.inColCharCode;
  });
  return result;
}
